/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { action, makeObservable, observable } from 'mobx';
import { Entry } from '../../types/course/Entry';

export class EntriesReviewModel {
	@observable
	public entries: Entry[] = [];

	@observable
	public newEntries: Entry[] = [];

	@observable
	public approvedEntries: Entry[] = [];

	@observable
	public rejectedEntries: Entry[] = [];

	@observable
	public pageNumberNewEntries = 1;

	@observable
	public pageNumberApproved = 1;

	@observable
	public pageNumberRejected = 1;

	@observable
	public numberOfPagesNewEntries = 0;

	@observable
	public numberOfPagesApproved = 0;

	@observable
	public numberOfPagesRejected = 0;

	@observable
	public entry: Entry | undefined = undefined;

	@observable
	public feedback = '';

	@observable
	public isPublishingView = false;

	@observable
	public isValidData = false;

	constructor() {
		makeObservable(this);
	}

	@action
	setEntries(entries: Entry[]): void {
		this.entries = entries;
	}

	@action
	setNewEntries(newEntries: Entry[]): void {
		this.newEntries = newEntries;
	}

	@action
	setApprovedEntries(approvedEntries: Entry[]): void {
		this.approvedEntries = approvedEntries;
	}

	@action
	setRejectedEntries(rejectedEntries: Entry[]): void {
		this.rejectedEntries = rejectedEntries;
	}

	@action
	setPageNumberNewEntries(pageNumber: number): void {
		this.pageNumberNewEntries = pageNumber;
	}

	@action
	setPageNumberApproved(pageNumber: number): void {
		this.pageNumberApproved = pageNumber;
	}

	@action
	setPageNumberRejected(pageNumber: number): void {
		this.pageNumberRejected = pageNumber;
	}

	@action
	setNumberOfPagesNewEntries(numberOfPages: number): void {
		this.numberOfPagesNewEntries = numberOfPages;
	}

	@action
	setNumberOfPagesApproved(numberOfPages: number): void {
		this.numberOfPagesApproved = numberOfPages;
	}

	@action
	setNumberOfPagesRejected(numberOfPages: number): void {
		this.numberOfPagesRejected = numberOfPages;
	}

	@action
	setEntry(entry: Entry | undefined): void {
		this.entry = entry;
	}

	@action
	public setFeedback(feedback: string): void {
		this.feedback = feedback;
	}

	@action
	public setIsPublishingView(bool: boolean): void {
		this.isPublishingView = bool;
	}

	@action
	public setIsValidData(bool: boolean): void {
		this.isValidData = bool;
	}
}
